<template>
  <div v-if="showOptionalTag" class="tags">
    <span class="tag-optional">Optional</span>
  </div>
</template>

<script>
export default {
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },

  computed: {
    showOptionalTag() {
      if (!this.asset.is_standard_programme_asset && this.asset.is_accessible && this.asset.asset_type === 'meeting') {
        return false;
      }
      return !this.asset.is_mandatory;
    },
  },
};
</script>
